<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="card-title mb-1">{{ guardian.username }}</h5>
          <p class="card-text text-muted mb-1">
            <i class="fas fa-phone me-2"></i> {{ guardian.phone_num }}
            <span v-if="guardian.sec_phone_num"> / {{ guardian.sec_phone_num }}</span>
          </p>
          <p class="card-text text-muted mb-1">
            <i class="fas fa-envelope me-2"></i> 
            {{ guardian.email || $t('guardian.notAvailable') }}
          </p>
          <p class="card-text text-muted">
            <i class="fas fa-map-marker-alt me-2"></i> {{ guardian.address }}
          </p>
        </div>
        <div class="text-end">
          <span class="badge bg-primary">{{ getRelationName(guardian.pivot.relation_type) }}</span>
          <p class="text-muted mb-0">{{ guardian.job || $t('guardian.notSpecified') }}</p>
          <p class="text-muted">{{ guardian.qualification || $t('guardian.notSpecified') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  guardian: {
    type: Object,
    required: true
  }
});

const getRelationName = (relation) => {
  const relations = {
    father: t("relations.father"),
    mother: t("relations.mother"),
    uncle: t("relations.uncle"),
    aunt: t("relations.aunt"),
    other: t("relations.other"),
  };
  return relations[relation] || relation;
};
</script>
